import {
    buildRecordLifecyclePagedListActions,
    type RecordLifecycleConfirmKind,
} from "../../utils/navigation/recordLifecycleActions";
import { EntityLabels } from "../../utils/navigation/pageTitles";

export type DrAdminConfirmKind = RecordLifecycleConfirmKind;

export function formatDrToastLabel(code: string | undefined): string {
    const t = typeof code === "string" ? code.trim() : "";
    return t.length > 0 ? t : EntityLabels.disposalRecoveryCode;
}

export function getDrAdminActionSuccessMessage(
    kind: DrAdminConfirmKind,
    code: string | undefined
): string {
    const label = formatDrToastLabel(code);
    const successByKind: Record<DrAdminConfirmKind, string> = {
        disable: `${label} disabled successfully!`,
        enable: `${label} enabled successfully!`,
        softDelete: `${label} deleted successfully!`,
        restore: `${label} restored successfully!`,
    };
    return successByKind[kind];
}

type DrRow = { id: string; code: string };

export const buildDrAdminPagedListActions = (openConfirm: (kind: DrAdminConfirmKind, item: DrRow) => void) =>
    buildRecordLifecyclePagedListActions<DrRow>(openConfirm, { activeMember: "isActive" });
